"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardMenuNoteFragment = void 0;
const client_1 = require("@apollo/client");
exports.standardMenuNoteFragment = client_1.gql `
  fragment StandardMenuNote on MenuNote {
    __typename
    id
    date
    text
    menuSectionId
  }
`;
//# sourceMappingURL=menuNote.js.map